import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import './NewReportDone.scss'
import { Elements, TextButton } from '@tfo/common'
import PopupView from '../../common/popupview/PopupView'
import RootStore from '../../../../stores/RootStore'
import { useStore } from '../../../../hooks/useStore'
import * as Common from '@tfo/common'

const { Heading1, Paragraph } = Elements

export interface NewReportDoneProps {
	rootStore?: RootStore
}

const NewReportDone = (props: NewReportDoneProps & WrappedComponentProps) => {
	const history = useHistory()
	const { companyId } = useParams<{ companyId: string }>()
	const { clientViewStore } = useStore()
	const externalHostedOrderFlow = clientViewStore.externalHostedOrderFlow


	// Using the event "visibilitychange" in order to trigger 
	// a removal of cookie without automatically reroute to login page
	const logoutAndStayInView = (): void => {
		if (externalHostedOrderFlow) {
			document.addEventListener("visibilitychange", () => {
				deleteSessionStorage()
			})
		}
	}

	const deleteSessionStorage = (): void => {
		window.sessionStorage.removeItem('externalHostedOrderFlow')
		window.sessionStorage.removeItem('individualInformation')
		Common.utils.deleteCookie()
	}

	React.useEffect(() => {
		logoutAndStayInView()
	}, [])

	return (
		<PopupView
			onCloseClick={() =>
				history.push(`/service-packages/${companyId}`)
			}
			className={'NewReportDone'}
			externalHostedOrderFlow={externalHostedOrderFlow}
		>
			<Heading1>
				<FormattedMessage id={'neworder.done.heading'} />
			</Heading1>
			<Paragraph className={'NewReportDone__BlockSpace--medium'}>
				<span>
					<FormattedMessage id={'neworder.done.body.row1'} />
				</span>
				<span>
					<FormattedMessage id={'neworder.done.body.row2'} />
				</span>
				<span>
					<FormattedMessage id={'neworder.done.body.row3'} />
				</span>
				<span>
					<FormattedMessage id={'neworder.done.body.row4'} />
				</span>
			</Paragraph>

			{externalHostedOrderFlow &&
				<Paragraph>
					<span>
						<FormattedMessage id={'neworder.done.body.externalOrder'} />
					</span>
				</Paragraph>
			}

			<TextButton
				className={'NewReportDone__BlockSpace--big'}
				onClick={() => history.push('/start')}>
				<FormattedMessage id={'neworder.done.cta'} />
			</TextButton>
		</PopupView>
	)
}

export default injectIntl(inject('rootStore')(observer(NewReportDone)))
